import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useForm, Controller } from 'react-hook-form'
import { match as Match } from 'react-router'
import { History, Location } from 'history'
import { useSelector, useDispatch } from 'react-redux'
import { Space, Input, Typography, Radio, Row, Col, Button, InputNumber } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import styled from 'styled-components/macro'

import { RadioChangeEvent } from 'antd/lib/radio/interface'
import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'
// import { Row } from '../../components/Grid'
import {
  selectedProfile,
  getProfileValidationResult,
  isLoading,
  isSaving,
  isValidating
} from '../../features/profile/selectors'
import { ProfileActions } from '../../features/profile/actions'
import { sendPhoto, updatePhoto } from '../../api/profile'
import { LoadingOverlay } from '../../components/Loading/LoadingOverlay'

const { Text } = Typography
const { TextArea } = Input

const SpaceFullWidth = styled(Space)`
  width: 100%;
`

const ContainerRow = styled(Row)`
  .ant-col {
    padding: 4px 20px;
  }

  .no-padding {
    padding: 0px;
  }
  .padding-right {
    padding: 0px 20px 0px 0px;
  }
  .align-right {
    display: flex;
    justify-content: flex-end !important;
  }
`
const SpaceHeader = styled(Space)`
  margin: 20px;
`

const StyledRadioGroup = styled(Radio.Group)<{ background: string; color: string }>`
  .ant-radio-button-wrapper-checked {
    background-color: ${({ background }) => background} !important;
    color: ${({ color }) => color} !important;
    border-color: ${({ color }) => color} !important;
    &::before {
      background-color: ${({ color }) => color} !important;
    }
  }
`

type EditProfileProps = {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
  match?: Match<{ hook_id: string }>
}

export const EditProfile: React.FC<EditProfileProps> = ({ history, match }: EditProfileProps) => {
  const dispatch = useDispatch()
  const profileId = _.get(match, 'params.profileId')

  const profile = useSelector(selectedProfile)
  const status = useSelector(getProfileValidationResult)
  const loading = useSelector(isLoading)
  const saving = useSelector(isSaving)
  const validating = useSelector(isValidating)

  // console.log('STATUS', status)

  // React Hook Form
  const { handleSubmit, errors, control, formState, register } = useForm({
    mode: 'onBlur'
  })

  const { isValid, isDirty } = formState

  // LOCAL State
  const [isChanged, setIsChanged] = useState({
    appearance: false,
    hair: false,
    size: false,
    breast: false,
    skin: false
  })

  const [appearance, setAppearance] = useState('')
  const [hair, setHair] = useState('')
  const [breast, setBreast] = useState('')
  const [skin, setSkin] = useState('')
  const [size, setSize] = useState('')
  const [avatar, setAvatar] = useState('')

  const [isNewProfile, setIsNewProfile] = useState(true)

  useEffect(() => {
    if (profileId === 'new') {
      dispatch(
        ProfileActions.updateSelectedProfile({
          name: '',
          bio: '',
          age: 20
        })
      )
      setIsNewProfile(true)
    } else {
      dispatch(ProfileActions.fetchProfileInfo('CaldeTentazioni', profileId))
      setIsNewProfile(false)
    }
  }, [dispatch, profileId])

  useEffect(() => {
    if (profile) {
      setAppearance(profile.appearance || 'normal')
      setHair(profile.hair || 'black')
      setBreast(profile.breast || 'normal_breast')
      setSkin(profile.skin || 'white_skin')
      setSize(profile.size || 'thin')
      if (profile && profile.photos) {
        setAvatar(`http://site-collaudo.caldetentazioni.com/images/profiles/${profile.photos[0].id}.jpg`)
      }
    }
  }, [profile])

  const handleChangeAppearance = (e: RadioChangeEvent) => {
    const newVal = e.target.value
    setAppearance(newVal)
    setIsChanged({ ...isChanged, appearance: newVal !== profile?.appearance })
  }

  const testChanged = () => {
    return isChanged.appearance || isChanged.breast || isChanged.hair || isChanged.size || isChanged.skin
  }

  const handleChangeHair = (e: RadioChangeEvent) => {
    const newVal = e.target.value
    setHair(newVal)
    setIsChanged({ ...isChanged, hair: newVal !== profile?.hair })
  }

  const handleChangeBreast = (e: RadioChangeEvent) => {
    const newVal = e.target.value
    setBreast(newVal)
    setIsChanged({ ...isChanged, breast: newVal !== profile?.breast })
  }

  const handleChangeSkin = (e: RadioChangeEvent) => {
    const newVal = e.target.value
    setSkin(newVal)
    setIsChanged({ ...isChanged, skin: newVal !== profile?.skin })
  }

  const handleChangeSize = (e: RadioChangeEvent) => {
    const newVal = e.target.value
    setSize(newVal)
    setIsChanged({ ...isChanged, size: newVal !== profile?.size })
  }

  const onSubmit = async (data: any) => {
    // eslint-disable-next-line no-console

    let newPhotoId = null

    if (data.picture[0]) {
      const formData = new FormData()
      formData.append('picture', data.picture[0])

      if (isNewProfile) {
        const resp = await sendPhoto(formData)
        // console.log(formData, data.picture[0], resp)
        if (_.get(resp, 'data.photoId')) {
          newPhotoId = resp.data.photoId
        }
      } else {
        const oldPhoto = profile && profile.photos ? profile.photos[0].id : ''
        updatePhoto(oldPhoto, formData)
        // console.log(resp)
      }
    }

    const newProfile = {
      ...profile,
      id: isNewProfile ? undefined : profile?.id,
      name: data.name,
      bio: data.bio,
      age: data.age,
      appearance,
      hair,
      size,
      skin,
      breast,
      photo: newPhotoId
    }

    dispatch(ProfileActions.startSavingProfile(newProfile))

    // console.log(newProfile)
    // setTimeout(
    //   () =>
    //     reset({
    //       name: profile?.name,
    //       bio: profile?.bio,
    //       age: profile?.age
    //     }),
    //   1000
    // )
  }

  if (!profile || loading) return <div>Loading...</div>

  // console.log(isChanged)
  // console.log(testChanged())

  return (
    <Page>
      <Layout>
        <LoadingOverlay loading={loading || saving || validating}>
          <SpaceHeader direction="horizontal" size={20}>
            <Button icon={<LeftOutlined />} onClick={() => history.goBack()}>
              Indietro
            </Button>

            <Title size="XL">{profile.name}</Title>
          </SpaceHeader>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ContainerRow justify="center" align="top">
              <Col flex="300px">
                <Space direction="vertical">
                  <Space direction="vertical">
                    <img src={avatar || ''} alt={profile.name} className="fixed-avatar" />
                  </Space>
                </Space>
              </Col>
              <Col flex="600px">
                <SpaceFullWidth direction="vertical" size={40}>
                  <Row>
                    <Col flex="auto" className="padding-right">
                      <SpaceFullWidth direction="vertical" size={0}>
                        <Space>
                          <Text strong>Nome</Text>
                        </Space>
                        <input
                          className="ant-input"
                          ref={register({
                            required: 'campo richiesto',
                            minLength: {
                              value: 3,
                              message: 'lunghezza minima 3 caratteri.'
                            }
                            // pattern: {
                            //   value: /[a-z].*/,
                            //   message: 'solo lettere e numeri'
                            // }
                          })}
                          name="name"
                          defaultValue={profile.name}
                          onChange={e => {
                            const newVal = _.trim(e.target.value)
                            if (newVal.length > 2) {
                              dispatch(ProfileActions.startProfileValidation({ id: profile.id, name: e.target.value }))
                            }
                            // }
                          }}
                        />
                        <span className="error-input">
                          {errors.name && <span>{errors.name.message}</span>}
                          {status && !status.isValid && <span>nome già in uso</span>}
                        </span>
                      </SpaceFullWidth>
                    </Col>
                    <Col flex="100px" className="no-padding">
                      <Space direction="vertical" size={0}>
                        <Text strong>Età</Text>
                      </Space>
                      <Controller
                        as={InputNumber}
                        name="age"
                        control={control}
                        defaultValue={profile.age}
                        rules={{ required: true, min: 18, max: 90 }}
                        value={profile.age}
                        min={18}
                        max={90}
                      />
                      <span className="error-input">{errors.age && <span>campo richiesto</span>}</span>
                    </Col>
                  </Row>
                </SpaceFullWidth>
                <SpaceFullWidth direction="vertical" size={0}>
                  <Text strong>Bio</Text>
                  <Controller
                    as={TextArea}
                    placeholder="Inserisci descrizione"
                    name="bio"
                    rows={9}
                    control={control}
                    defaultValue={profile.bio}
                    value={profile.bio}
                  />

                  <span className="error-input">&nbsp;</span>
                </SpaceFullWidth>
              </Col>
              <Col flex="auto">
                <Space direction="vertical" size={16}>
                  <Space direction="vertical" size={0}>
                    <Text strong>Aspetto</Text>
                    <StyledRadioGroup
                      background="#fffbe6"
                      color="#faad14"
                      size="small"
                      onChange={handleChangeAppearance}
                      defaultValue="normal"
                      value={appearance || profile.appearance}
                      buttonStyle="solid"
                    >
                      <Radio.Button value="ugly">Ugly</Radio.Button>
                      <Radio.Button value="normal">Normal</Radio.Button>
                      <Radio.Button value="top_model">Top model</Radio.Button>
                    </StyledRadioGroup>
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text strong>Pelle</Text>
                    <StyledRadioGroup
                      background="#fff0f6"
                      color="#eb2f96"
                      size="small"
                      onChange={handleChangeSkin}
                      defaultValue="white_skin"
                      value={skin || profile.skin}
                      buttonStyle="solid"
                    >
                      <Radio.Button value="white_skin">Bianca</Radio.Button>
                      <Radio.Button value="black_skin">Nera</Radio.Button>
                      <Radio.Button value="yellow_skin">Gialla</Radio.Button>
                    </StyledRadioGroup>
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text strong>Capelli</Text>
                    <StyledRadioGroup
                      background="#fff2e8"
                      color="#fa541c"
                      size="small"
                      onChange={handleChangeHair}
                      defaultValue="black"
                      value={hair || profile.hair}
                      buttonStyle="solid"
                    >
                      <Radio.Button value="black">Neri</Radio.Button>
                      <Radio.Button value="brown">Castani</Radio.Button>
                      <Radio.Button value="blonde">Biondi</Radio.Button>
                      <Radio.Button value="red">Rossi</Radio.Button>
                    </StyledRadioGroup>
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text strong>Seno</Text>
                    <StyledRadioGroup
                      background="#f9f0ff"
                      color="#722ed1"
                      size="small"
                      onChange={handleChangeBreast}
                      defaultValue="normal_breast"
                      value={breast || profile.breast}
                      buttonStyle="solid"
                    >
                      <Radio.Button value="small_breast">Piccolo</Radio.Button>
                      <Radio.Button value="normal_breast">Normale</Radio.Button>
                      <Radio.Button value="big_breast">Grande</Radio.Button>
                    </StyledRadioGroup>
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text strong>Size</Text>
                    <StyledRadioGroup
                      background="#e6fffb"
                      color="#13c2c2"
                      size="small"
                      onChange={handleChangeSize}
                      defaultValue="petite"
                      value={size || profile.size}
                      buttonStyle="solid"
                    >
                      <Radio.Button value="petite">Piccola</Radio.Button>
                      <Radio.Button value="thin">Magra</Radio.Button>
                      <Radio.Button value="fat">Grassa</Radio.Button>
                    </StyledRadioGroup>
                  </Space>
                </Space>
              </Col>
            </ContainerRow>
            <ContainerRow justify="space-between">
              <Col md={6}>
                <input
                  ref={register}
                  type="file"
                  name="picture"
                  onChange={e => {
                    if (e.target.files && e.target.files?.length > 0) {
                      // console.log(e.target.files[0])
                      setAvatar(URL.createObjectURL(e.target.files[0]))
                    }
                  }}
                />
              </Col>
              <Col md={6} className="align-right">
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={saving || (status && !status.isValid) || !isValid || (!isDirty && !testChanged())}
                >
                  SALVA
                </Button>
              </Col>
            </ContainerRow>
          </form>
        </LoadingOverlay>
      </Layout>
    </Page>
  )
}
